
import React from 'react';

const tools = [
  { 
    icon: 'ri-team-line', 
    title: 'Unified Lead Management', 
    description: 'Capture leads directly from social media and publish promotions across platforms from one dashboard.' 
  },
  { 
    icon: 'ri-flight-takeoff-line', 
    title: 'One-Click Comparison', 
    description: 'Instantly compare flight fares from top global suppliers in a single, high-speed search.' 
  },
  { 
    icon: 'ri-magic-line', 
    title: 'AI Itinerary Builder', 
    description: 'Create personalized, professional travel itineraries in under 2 minutes using advanced AI.' 
  },
  { 
    icon: 'ri-earth-line', 
    title: '1,000+ Global DMCs', 
    description: 'Direct access to thousands of international DMCs for competitive pricing and exclusive inventory.' 
  },
  { 
    icon: 'ri-rocket-2-line', 
    title: 'Instant Portal Launch', 
    description: 'Deploy your B2C, B2B, or Corporate travel portal with full mobile optimization in clicks.' 
  },
  { 
    icon: 'ri-plug-2-line', 
    title: 'Supplier Integration', 
    description: 'Instant connectivity with industry leaders like TBO, TripJack, Riya, and AirIQ.' 
  },
  { 
    icon: 'ri-calculator-line', 
    title: 'Smart Accounting', 
    description: 'Automated invoicing, supplier payments, and financial reporting built for travel pros.' 
  },
  { 
    icon: 'ri-layout-grid-line', 
    title: 'All-in-One Travel CRM', 
    description: 'A complete ecosystem for Flights, Hotels, Buses, Holidays, Visas, and Transfers.' 
  },
];

const ToolCard = ({ icon, title, description }) => (
  <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
    <div className="feature-card h-100">
      <div className="icon-wrapper">
        <i className={`${icon}`}></i>
      </div>
      <h5 className="feature-title">{title}</h5>
      <p className="feature-description">{description}</p>
      <div className="card-accent"></div>
    </div>
  </div>
);

export default function ToolsSection() {
  return (
    <section className="py-5" style={{ backgroundColor: '#ffffff', position: 'relative', overflow: 'hidden' }}>
      {/* Subtle Background Decoration */}
      <div style={{
        position: 'absolute', top: '-10%', right: '-5%', width: '400px', height: '400px',
        background: 'radial-gradient(circle, rgba(13, 110, 253, 0.05) 0%, rgba(255,255,255,0) 70%)',
        zIndex: 0
      }}></div>

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <span className="badge rounded-pill mb-3 px-3 py-2" style={{ backgroundColor: '#e7f0ff', color: '#0d6efd', letterSpacing: '1px', fontSize: '12px', fontWeight: '700' }}>
              ENTERPRISE GRADE TOOLS
            </span>
            <h2 className="display-5 fw-bold mb-3" style={{ color: '#0f172a' }}>
              Travel Technology for the <span style={{ color: '#0d6efd' }}>Modern Agency</span>
            </h2>
            <p className="text-muted fs-5">Everything you need to automate, scale, and dominate the travel market.</p>
          </div>
        </div>

        <div className="row g-4">
          {tools.map((tool, index) => (
            <ToolCard key={index} {...tool} />
          ))}
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .feature-card {
          background: #ffffff;
          border: 1px solid #f1f5f9;
          padding: 2rem;
          border-radius: 20px;
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
          position: relative;
          display: flex;
          flex-direction: column;
          cursor: default;
        }

        .feature-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.06);
          border-color: #0d6efd40;
        }

        .icon-wrapper {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #0d6efd 0%, #0048af 100%);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
          color: white;
          font-size: 1.75rem;
          box-shadow: 0 10px 20px rgba(13, 110, 253, 0.2);
          transition: transform 0.3s ease;
        }

        .feature-card:hover .icon-wrapper {
          transform: scale(1.1) rotate(5deg);
        }

        .feature-title {
          font-weight: 700;
          font-size: 1.15rem;
          color: #1e293b;
          margin-bottom: 0.75rem;
        }

        .feature-description {
          color: #64748b;
          font-size: 0.95rem;
          line-height: 1.6;
          margin-bottom: 0;
        }

        .card-accent {
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0;
          height: 3px;
          background: #0d6efd;
          transition: all 0.3s ease;
          border-radius: 3px;
          transform: translateX(-50%);
        }

        .feature-card:hover .card-accent {
          width: 40%;
        }
      `}} />
    </section>
  );
}